var dealerLocatorManager = (function(){
    var initialised = false;
    var currentScenario = {
        "brand" :$("select#brand-field").find(':selected').data('custom-id'),
        "enableDealerLocator" : "1",
        "target" :"private"
    }

    function init()
    {
        if(initialised){
            return;
        }
        initialised = true;
        if(!$(".dealer-locator-container").length) return;

        if (typeof google !== typeof undefined) {
            var input = document.getElementById('dealerSearchTextField');
            var autocomplete = new google.maps.places.Autocomplete(input);
            autocomplete.setComponentRestrictions({ country: [ENV.market] });
            google.maps.event.addListener(autocomplete, 'place_changed', function () {
                var place = autocomplete.getPlace();
                var address = place.formatted_address;
                handleAddressChange(address);
            });
        }

        document.getElementById('localizzamiBtn').addEventListener('click', function () {
            navigator.geolocation.getCurrentPosition(
                function (position) {
                    var lat = position.coords.latitude;
                    var lng = position.coords.longitude;
                    var latlng = new google.maps.LatLng(lat, lng);
                    
                    var geocoder = new google.maps.Geocoder();
                    geocoder.geocode({ location: latlng }, function (results, status) {
                        if (status === 'OK' && results[0]) {
                            var address = results[0].formatted_address;
                            document.getElementById('dealerSearchTextField').value = address;
                            handleAddressChange(address);
                        }
                    });
                }
            );
        });

        $(document).on('change', 'input[type=radio][name=dealer]', function() {
            handleDealerSelection($(this));
        });

        $(document).on('change', 'select#brand-field', function() {
            currentScenario.brand = $(this).find(':selected').data('custom-id')
            currentScenario.enableDealerLocator = $(this).find(':selected').data('is-dealer-locator-worthy')
            handleEnableDealerLocator();
        });

        $(document).on('change', 'select#target', function() {
            currentScenario.target = $(this).find(':selected').val()
            handleEnableDealerLocator();
        });


    }

    function handleEnableDealerLocator()
    {
        if((currentScenario.brand != "" && currentScenario.brand != undefined) && currentScenario.enableDealerLocator != "" && (currentScenario.target == 'professional' || currentScenario.target == 'corporate'  ) )
        {
            $("form .dealer-locator-container").removeClass("d-none");
            $("form input[name=dealer_locator]").attr("data-validate-required", "true");
            dealersPlace = $(".dealer-locator-container .dealers-list-place");
            dealersPlace.empty();
        } else {
            $("form .dealer-locator-container").addClass("d-none");
            $("form input[name=dealer_locator]").attr("data-validate-required", "false");
        }

        //RESET ALWAYS ON CHANGE
        $("form input[name=tradeName]").val("")
        $("form input[name=physicalRRDI7]").val("")
        $("form input[name=siteGeo]").val("");
        $("form input[name=dealer_locator]").val("")

    }

    function handleAddressChange(address)
    {
        getDealers(address);
    }
    
    function toggleLoader(show)
    {
        if (show) {
            $(".dealer-locator-container .loader-container").removeClass("d-none");
        } else {
            $(".dealer-locator-container .loader-container").addClass("d-none");
        }
    }

    function toggleAlert(show)
    {
        if (show) {
            $(".dealer-locator-container .alert-section").removeClass("d-none");
        } else {
            $(".dealer-locator-container .alert-section").addClass("d-none");
        }
    }
    
    function getDealers(address)
    {
        dealersPlace = $(".dealer-locator-container .dealers-list-place");
        dealersPlace.empty();

        toggleAlert(false);
        toggleLoader(true)

        var filters = {
            country: ENV.market == 'uk' ? 'gb' : ENV.market,
            address: address,
            language: ENV.language,
            brand: currentScenario.brand
        }
        $.ajax({
            method:"GET",
            url: "/api/v1/getDealersByFullAddress",
            data: filters,
            success: function(res){
                dealers = res.dealers
                renderDealers(dealers)
            },
            error: function(err){
                if(err.status == 404){
                    toggleLoader(false);
                    dealersPlace = $(".dealer-locator-container .dealers-list-place");
                    dealersPlace.empty();
                    dealersPlace.append('<div class="col-12"><span id="">' + LABELS.zipCode.noResult + '</span></div>');

                } else {
                    toggleAlert(true);
                    toggleLoader(false);
                }
                
                
            }
        })
    }

    function renderDealers(dealers)
    {
        dealersPlace = $(".dealer-locator-container .dealers-list-place");
        dealersPlace.empty();
        handleDealerSelection();

        template = $(".dealer-locator-container #single-dealer-template").prop("content");
        
        dealers.forEach(d => {
            const $clone = $(template).clone();
            $clone.find("span.dealer-name").text(d.dealer_name);
            $clone.find("p.dealer-address").text(d.dealer_address
                .split(',')
                .map(part => {
                    const trimmed = part.trim();
                    return trimmed.charAt(0).toUpperCase() + trimmed.slice(1).toLowerCase();
                })
                .join(', '));
            $clone.find("span.distance").text(d.dealer_distance);
            $clone.find("input").attr("data-trade-name", d.dealer_name);
            $clone.find("input").attr("data-physicalrrdi7", d.dealer_code);
            $clone.find("input").attr("value", d.dealer_code);
            $clone.find("input").attr("data-site-geo", d.dealer_sitegeo);
            dealersPlace.append($clone);
        });
        toggleLoader(false);
    }

    function handleDealerSelection(dealerElement = null)
    {
        $(".single-dealer-container").removeClass("selected");

        if(!dealerElement){
            $("form input[name=tradeName]").val("")
            $("form input[name=physicalRRDI7]").val("")
            $("form input[name=siteGeo]").val("");
            $("form input[name=dealer_locator]").val("")
            return;
        }
        
        dealerElement.closest(".single-dealer-container").addClass("selected");

        $("form input[name=tradeName]").val(dealerElement.attr("data-trade-name"))
        $("form input[name=physicalRRDI7]").val(dealerElement.attr("data-physicalRRDI7"))
        $("form input[name=dealer_locator]").val(dealerElement.attr("data-physicalRRDI7"))
        $("form input[name=siteGeo]").val(dealerElement.attr("data-site-geo"))
    }



    return {
        init:init,
        handleAddressChange: handleAddressChange
    }
})(jQuery)